import urlPrefix from "./apiPrefix";

export const putApplyingConditionsUpdate = () => `${urlPrefix.value}/tax-web-control/api/applying_conditions/update`;
export const postApplyingConditionsCreate = () => `${urlPrefix.value}/tax-web-control/api/applying_conditions/create`;
export const getApplyingConditions = (id: number) => `${urlPrefix.value}/tax-web-control/api/applying_conditions/${id}`;
export const deleteApplyingConditions = (id: number) => `${urlPrefix.value}/tax-web-control/api/applying_conditions/delete/{id}`;
